<template>
    <div id="advertisement">
        <c-body class="c-body">
            <div slot="before-header">
                <Tabs :value="currentTab" @on-click="onClickTab">
                    <TabPane label="打款记录" name="pmt-series"></TabPane>
                    <TabPane label="账号余额" name="pmt-balance"></TabPane>
                </Tabs>
            </div>
            <div slot="section">
                <router-view></router-view>
            </div>
        </c-body>
    </div>
    </template>
    <script>
    import cBody from '@/components/commons/cBody.vue';
    export default {
        name: 'Advertisement',
        components: {
            cBody
        },
        computed: {
            currentTab() {
                return this.$route.name;
            }
        },
        methods: {
            /*
             * @description 点击tab，切换导航
             * @param link:string 路由地址
             */
            onClickTab(link) {
                // 无效排序返回
                this.$router.push({ name: link });
            }
        }
    };
    </script>


// WEBPACK FOOTER //
// src/view/Payment/PaymentRecord.vue